import { Component, OnInit } from '@angular/core';
import CONFIG from 'config';

import { Subscription } from 'rxjs/Subscription';
import { MultiColumnGridService } from 'app/shared/multi-column-grid.service';
import { BackendService } from 'app/shared/backend.service';
import { AuthService } from 'app/shared/auth.service';
import { AccountService } from 'app/shared/account.service';
import { NotificationService } from 'app/notification/notification.service';
import { SearchService } from 'app/shared/search.service';
import { OrderByService } from 'app/shared/orderby.service';
import { PaginationService } from 'app/shared/pagination.service';
import { FilterService } from 'app/shared/filter.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Location,DecimalPipe, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-positions-container',
  templateUrl: './positions-container.component.html',
  //styleUrls: ['./positions-container.component.scss']
  providers: [DecimalPipe, PaginationService]
})
export class PositionsContainerComponent  extends MultiColumnGridService implements OnInit {
  currency: any;
   totalmarketvalue: any;
   FilterByStatus: FormGroup;
      constructor(  public location: Location,
          public backendService: BackendService,
          public authService: AuthService,
          public accountService: AccountService,
          public notificationService: NotificationService,
          public formBuilder: FormBuilder,
          public searchService: SearchService,
          public orderByService: OrderByService,
          public router: Router,
          public paginationService: PaginationService,
          public filterService: FilterService,
          public numberPipe: DecimalPipe,
          public currencyPipe: CurrencyPipe) {
              super(location, backendService, authService, notificationService, formBuilder,
              searchService, orderByService, router, paginationService, currencyPipe, filterService);
          }
   ngOnInit() {
       //this.apiUrl = CONFIG.positionsApiUrlBase;
  }

}
